import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UtilErrorMsgComponent } from './util-error-msg.component';


@NgModule({
  declarations: [UtilErrorMsgComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [UtilErrorMsgComponent]
})
export class UtilErrorMsgModule { }
